import { ValentineState } from "@/components/ValentinePopup/redux/types";

export const valentineInitialState: ValentineState = {
  isImageGenerating: false,
  isOpenShareModal: false,
  isOpenValentineModal: true,
  imageName: "",
  error: null,
};
